import { render, staticRenderFns } from "./DiscordCallback.vue?vue&type=template&id=2530a9eb&scoped=true"
import script from "./DiscordCallback.vue?vue&type=script&lang=ts"
export * from "./DiscordCallback.vue?vue&type=script&lang=ts"
import style0 from "./DiscordCallback.vue?vue&type=style&index=0&id=2530a9eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530a9eb",
  null
  
)

export default component.exports